import { FC, useEffect, useState } from "react";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import { isBiometricSetUpCompleted } from "../../utils/helper";
import CsLocalStorageUtils from "../../utils/CsLocalStorageUtils";
import CaptureBiometric from "../../features/Feature_GeneralAppElements/CaptureBiometric/CaptureBiometric";
import { Outlet } from "react-router-dom";
import { isEmpty } from "lodash";
import CsSessionStorageUtils from "../../utils/CsSessionStorageUtils";
import { E_ChannelOptions } from "../../globalTypes/GlobalTypes";
import { DEVICE_TYPE, REGISTER_BIO_METRIC } from "../../utils/constants";
import { getCookie } from "../../utils/CSCookieHandler";

export const BioMetricGuard: FC = () => {
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const deviceType = useDeviceDetection();
  const mobile = CsLocalStorageUtils.get("MOBILE");
  const csUserId = CsLocalStorageUtils.get("CS_USER_ID");
  const [loadScreen, setLoadScreen] = useState<
    "home" | "biometric" | "loading"
  >("loading");
  useEffect(() => {
    const biometricDoItLaterValue = getCookie("BIOMETRIC_DO_IT_LATER_STATUS");
    let bioInfo = null;
    if (csAppSlice.NativeDeviceInfo?.systemName === 'Android') {
      bioInfo = csAppSlice.NativeDeviceInfo?.bioInfo;
    } else {
      bioInfo = JSON.parse(getCookie(REGISTER_BIO_METRIC) as any);
    }

    console.log("Is Bio Setup Completed", isBiometricSetUpCompleted(mobile, csUserId, bioInfo));

    if (csAppSlice.channel === E_ChannelOptions.CSAPP &&
      !isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)) {
        if(csAppSlice.NativeDeviceInfo?.systemName === 'iOS') {
          setLoadScreen(
            csAppSlice.channel === E_ChannelOptions.CSAPP &&
              !isEmpty(csAppSlice.NativeDeviceInfo?.deviceName) &&
              (deviceType === DEVICE_TYPE.PWA_MOBILE ||
                deviceType === DEVICE_TYPE.MOBILE) &&
              !isBiometricSetUpCompleted(mobile, csUserId, bioInfo) &&
              biometricDoItLaterValue !== "true"
              ? "biometric"
              : "home"
          );
        } else if((csAppSlice.NativeDeviceInfo?.bioInfo === null || csAppSlice.NativeDeviceInfo?.bioInfo === undefined ) && csAppSlice.NativeDeviceInfo?.systemName === 'Android' && !biometricDoItLaterValue){
          setLoadScreen('biometric');
        } else {
          setLoadScreen('home');
        }
    } else {
      setLoadScreen('home');
    }
    
  }, []);
  const onHide = () => {
    setLoadScreen("home");
  };
  console.log(loadScreen);
  return loadScreen === "loading" ? (
    <></>
  ) : loadScreen === "biometric" ? (
    <CaptureBiometric onHide={onHide} />
  ) : (
    <Outlet />
  );
};
